module.exports = __webpack_public_path__ + "static/media/help-background.8b9f6e3d.jpg";